import { AutoMap } from "@automapper/classes";

export class GlobalTask {
    @AutoMap()
    Position!: number;
    @AutoMap()
    Description!: string;

    public constructor(init?: Partial<GlobalTask>) {
        Object.assign(this, init);
    }
}